import { createBrowserHistory, createMemoryHistory } from 'history'
import { isBrowser } from '../utils/ssr'

export const history = isBrowser()
  ? createBrowserHistory()
  : createMemoryHistory()
